import React, { useState } from "react";
import WrappingContainer from "../../HOC/WrappingContainer/WrappingContainer";
import SearchInput from "../../Atoms/Inputs/SearchInput";
import Buttons from "../../Atoms/Buttons/Buttons";
import plus from "../../../assets/Imagess/plusvector.svg";
import styles from "./EmailPage.module.css";
import searchIcon from "../../../assets/Imagess/searchicon.svg";
import EmailTable from "../../Molecules/Email/EmailTable";
import { useNavigate } from "react-router-dom";
import {
  useDeleteEmail,
  useFetchNotifications,
} from "../../../Hooks/Notification";
import DeletePopup from "../../Molecules/Custom/DeletePopup";
import { useEmailContext } from "../../../Context/EmailContext";
import Loader from "../../Molecules/Loader/Loader";
import EmailFilter from "../../Molecules/Filter/EmailFilter";

const EmailPage = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState({});
  const [search, setSearch] = useState();
  const navigate = useNavigate();
  const {
    data: emails,
    refetch: refetchEmails,
    isLoading: isEmailLoading,
  } = useFetchNotifications();
  const { mutate: deleteEmail, isLoading: isDeletingEmail } = useDeleteEmail();

  const { setNewSelectedEmail } = useEmailContext();

  const handleDelete = () => {
    if (selectedEmail && selectedEmail.notificationId) {
      deleteEmail.mutate(selectedEmail.notificationId, {
        onSuccess: () => {
          setShowDeleteModal(false);
          refetchEmails();
        },
        onError: (error) => {
          console.error("Error deleting email", error);
        },
      });
    }
  };

  const handleEdit = (email) => {
    setNewSelectedEmail(email);
    navigate("/home/new-email");
  };

  return (
    <>
      <div className={styles["email-container"]}>
        <h2>Email Templates</h2>
        <div className={styles["icon-container"]}>
          <SearchInput
            icon={searchIcon}
            search={search}
            setSearch={setSearch}
          />
          <div className={styles["icon-subcontainer"]}>
            <Buttons
              text="New Template"
              icon={plus}
              rounded={true}
              color="#F3223C"
              to="/home/new-email"
            />
            <EmailFilter />
          </div>
        </div>
        <EmailTable
          data={emails?.data}
          setShowDeleteModal={setShowDeleteModal}
          setSelectedEmail={setSelectedEmail}
          handleEdit={handleEdit}
          isEmailLoading={isEmailLoading}
          refetchEmails={refetchEmails}
        />
      </div>
      {showDeleteModal && (
        <DeletePopup
          handleOnClose={() => (
            setShowDeleteModal(false), setSelectedEmail({})
          )}
          title={selectedEmail?.notificationName}
          handleDelete={handleDelete}
          isLoading={isDeletingEmail}
        />
      )}
    </>
  );
};

export default EmailPage;
